package com.essntl.features.organization.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.organization.data")
class OrganizationModule